import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { useResume } from '../context/ResumeContext';
import { ADDITONAL_PREDEFINE_SECTIONS, MONTHS } from '../constants/constants';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import { usePopup } from '../context/PopupContext';
import { formatDate, rbDate2String, removeBodyScroll } from '../helper';
import DraftEditor from './common/DraftEditor';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import DraggableIcon from '../assets/images/draggable-icon.svg';

const References = (props) => {
  const {
    resume: {
      heading: { fname },
      references,
      enabled_tabs
    },
    handlers: {
      updateResumePreview,
    },
  } = useResume();
  const popupbox = usePopup();
  let grid = references.hasOwnProperty('grid') ? references.grid : {};
  const emptyrow = ADDITONAL_PREDEFINE_SECTIONS.references.struct.grid.row_1
  const [checkField, setCheckField] = useState('');
  useEffect(() => {
    // if (!references.hasOwnProperty('grid')) {
    //   let struct = { ...emptyrow };
    //   struct.content = references.content;
    //   updateResumePreview({ references: { ...references, grid: { row_1: { ...struct } } } });
    // }

  }, []);

  const updateRow = (input, id) => {
    const row = {
      [id]: {//example references_1
        ...grid[id],
        ...input
      }
    }
    updateResumePreview(
      { references: { ...references, grid: { ...grid, ...row } }, current_tab: 'additional_sections',  }
    )
  }
  const addRow = (newname = '') => {
    const id = 'row_' + Math.floor(Math.random() * 1000)
    const row = { ...emptyrow }
    /**
     * START
     * Changes to close automatically the previously opened tabs on adding a new one
     * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/530
     * Date: 2024-01-05
     */
    grid = Object.keys(grid).map(key => {
      return {...grid[key], open: false}
    })
    /**
     * END
     */
    updateResumePreview(
      { references: { ...references, grid: { ...grid, [id]: { ...row } } }, current_tab: 'additional_sections',  }
    )
  }
  const deleteRow = (id) => {
    if (grid.hasOwnProperty(id)) {
      let t = { ...grid }
      delete t[id]
      if (!Object.keys(t).length) {//Last need to handle with default gridtings
        const newid = 'row_' + Math.floor(Math.random() * 1000)
        t = { [newid]: { ...emptyrow } }
      }
      updateResumePreview({ references: { ...references, grid: { ...t } }, current_tab: 'additional_sections' })
    }
  }
  const fieldFocus = (e, id) => {
    setCheckField(e.target.name + '-' + id)
  }
  const fieldBlur = (e, id) => {
    setCheckField('');
  }

  const TabStatus = props => <div className="arrow-action" onClick={props.onClick}> {props.t ? <i className="icon-chevron-left"></i> : <i className="icon-right-arrow"></i>}</div>;

  const onDragEnd = result => {
    const { destination, source, draggableId } = result;
    if (!destination) return
    if (destination.droppableId === source.droppableId && destination.index === source.index) return
    const grid1 = {};
    let ids = Object.keys(references.grid), grid = {};
    ids.splice(source.index, 1)
    ids.splice(destination.index, 0, draggableId)
    ids.forEach(element => {
      const id = 'row_' + Math.floor(Math.random() * 1000)
      grid1[id] = { ...references.grid[element] }
      //grid1.push( { ...section.grid[element] })
      })
    updateResumePreview(
      { 
        references: { 
          ...references, 
          grid: {...grid1},
        }, current_tab: 'additional_sections',  }
    )    
  }

  return (<DragDropContext onDragEnd={onDragEnd}>
  <div className="editor-form references-blocks">
  <Droppable droppableId={'unrelavent'}>
    {(provided) => (
    <div 
      ref={provided.innerRef} 
      {...provided.droppableProps}
      >
    {Object.keys(grid).map((id,index) => (
      <Draggable draggableId={id} index={index} key={id}>
          {(provided, snapshot) => (
      <div className="sub-list-wrap" key={id} ref={provided.innerRef} {...provided.draggableProps}>
        <div className="sub-list" onClick={() => (updateRow({ open: !grid[id].open }, id))}>
          <div className='addtiaonl-section-reorder'>
            <div className="reorder">
                    <div type="button" className="btn btn-link" dataid={id} {...provided.dragHandleProps}><DraggableIcon /></div>
            </div>
            <span className="sub-name">{grid[id].name.length ? grid[id].name : 'Reference'}</span>
          </div>
          <div className="controls">
            <div className="delete-action">
              <span onClick={(e) => {popupbox.show('row_delete', null, () => deleteRow(id)), removeBodyScroll(true)}}>
                <DeleteIcon />
              </span>
            </div>
            <TabStatus t={grid[id].open} onClick={() => (updateRow({ open: !grid[id].open }, id))} />
          </div>
        </div>
        {grid[id].open && <div className="sub-form">
          <div className="form-row column-2">
           
            <div className="field-wrap">
              {/* <label htmlFor="name" className={`label${checkField == 'name-' + id ? ' label-focus' : ''}`}>Reference Name</label> */}
              <input
                placeholder="Reference Name"
                type="text"
                name="name"
                onChange={(e) => {
                  updateRow({ name: e.target.value }, id)
                  //e.target.value
                }}
                value={grid[id].name}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
            <div className="field-wrap">
              {/* <label htmlFor="reference_reletionship" className={`label${checkField == 'reference_reletionship-' + id ? ' label-focus' : ''}`}>Relationship to Reference</label> */}
              <input
                placeholder="Relationship to Reference"
                type="text"
                name="reference_reletionship"
                onChange={(e) => {
                  updateRow({ reference_reletionship: e.target.value }, id)
                  //e.target.value
                }}
                value={grid[id]?.reference_reletionship}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
          </div>
          <div className="form-row column-2">
            <div className="field-wrap date-field">
              {/* <label htmlFor="start_date" className={`label${checkField == 'start_date-' + id ? ' label-focus' : ''}`}>Start Date</label> */}
              <DatePicker
                showMonthYearPicker
                //value={}
                placeholderText="Start Date"
                value={formatDate(grid[id].start_date)}
                selected={formatDate(grid[id].start_date)}
                name="start_date"
                className="form-input borderaccent custom-date-picker"
                dateFormat="MMMM yyyy"
                disabled={false}
                autoComplete="off"
                onChange={e => updateRow({ start_date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                onChangeRaw={e => e.preventDefault()}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
            <div className="field-wrap date-field">
              {/* <label htmlFor="end_date" className={`label${checkField == 'end_date-' + id ? ' label-focus' : ''}`}>End Date</label> */}
              <DatePicker
                showMonthYearPicker
                //value={}
                placeholderText="End Date"
                value={formatDate(grid[id].end_date)}
                selected={formatDate(grid[id].end_date)}
                name="end_date"
                className="form-input borderaccent custom-date-picker"
                dateFormat="MMMM yyyy"
                disabled={false}
                autoComplete="off"
                onChange={e => updateRow({ end_date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                onChangeRaw={e => e.preventDefault()}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="field-wrap">
              <label htmlFor="description" className="label editor-label">Summary</label>
              <DraftEditor
                name="description"
                // placeholder="e.g. Passionate science teacher with 8+ years of experience and a track record of..."
                className="validate"
                value={grid[id]?.content ?? ''}
                onInputChange={val => updateRow({ content: val }, id)}
              />
            </div>
          </div>
          
        </div>}
      </div>
       )}
      </Draggable>
    ))}         
    {provided.placeholder}
    </div>
    )}
     </Droppable>
    <div className="add-more-wrap">
      <span
        className="add-more-skills"
        onClick={(e) => {
          addRow()
        }}>
        <i className="icon-plus-icon"></i> Add one more
      </span>
    </div>
  </div></DragDropContext>);
}

export default References;